import luantiLogo from "./assets/Luanti_logo.png";
import serverInfoImage from "./assets/servidorcito-info.png";
import "./app.css";

import { LocationProvider } from "preact-iso";

export function App() {
  return (
    <LocationProvider>
      <header>
        <div className="start">
          <img src={luantiLogo} alt="logo luanti" width={50} />
          <h1>Servidorcito de Simx72</h1>
        </div>
        <div className="end">
          {/* <a href="#intro">Como conectarse?</a> */}
        </div>
      </header>
      <main>
        <div id="intro">
          <div id="intro-inner">
            <img
              src={serverInfoImage}
              alt="Info para conectarse al servidorcito: Dirección mineclonia.simx72.com, puerto 30000, contraseña servidorcito, y el nombre que tu elijas ! Pulsa Iniciar sesión y listo!"
            />
          </div>
        </div>
      </main>
    </LocationProvider>
  );
}
